import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.205 3.205A.7.7 0 0 1 3.7 3h8.6a.7.7 0 0 1 .7.7v1.178a.7.7 0 0 1-.148.431L9.965 9v2.534a.7.7 0 0 1-.497.67l-2.53.766a.7.7 0 0 1-.902-.67V9L3.149 5.31A.7.7 0 0 1 3 4.877V3.7a.7.7 0 0 1 .205-.495ZM4.4 4.4v.237l2.887 3.69a.7.7 0 0 1 .149.432v2.598l1.129-.342V8.759a.7.7 0 0 1 .149-.431L11.6 4.637V4.4H4.4Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=FilterIcon16.js.map